import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import {
  extractVehiciesByIdFailed, extractVehiciesByIdSuccessful,
} from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { CREATED, OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL } from '../../../configs';

export default function* extractCarrierById(action) {
  try {
    if (!action.payload || !action.payload.id) {
      throw new Error('ID not found');
    }
    const url = `${BACKEND_URL}/registries/vehicles/${action.payload.id}/extract`;
    const dataResponse = yield makeRequest(url, {}, action, 'GET', true);
    const data = yield dataResponse.json();
    if (dataResponse.status === OK || dataResponse.status === CREATED) {
      yield put(extractVehiciesByIdSuccessful(data.data));
      yield call(resolveActionPromise(action, data.data));
    } else {
      yield put(extractVehiciesByIdFailed());
      yield call(rejectActionPromise(action));
    }
  } catch (e) {
    yield put(extractVehiciesByIdFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
